<template>
<div class="chapter">
<div class="inner_page">
<p class="h2">Acknowledgments</p>
<p class="noindent">Many people have given generously of their time and knowledge to make this a better book. For critical reviews of an earlier version of the manuscript or portions of it, I wish to thank Roger Abrahams, Dell Hymes, Joan Foster McCarty, Stan Newman, Bruce Spivey, and John Szwed. For a critical reading of the present manuscript or various chapters I wish to thank Larry Fisher, Allen Harris, and Stan Newman. For being generally on call to give me critical reaction when I needed it, I am especially grateful to Allen Harris, Grace Holt, Joan Foster McCarty, and Stan Newman.</p>
<p class="indent">For valuable editorial help with portions of the manuscript, I wish to thank Isabel Grossner and Carolyn Mullins. For helpful editorial advice and criticism I also wish to thank Anthony Graham-White and Frank Williams.</p>
<p class="indent">I also owe a great debt of thanks to my students, usually the first group to respond critically to my views about cultural differences between blacks and whites. They also provided me with examples from their own experience that I have used extensively for both documentation and illustration throughout the book.</p>
<p class="indent">For her unflagging good will and care in typing the manuscript, I wish to thank Marquita Hampton.</p>
<p class="indent">My deepest thanks go to my wife Alexandra, whose unwavering support and encouragement sustained me spiritually through the entire project. I also wish to thank my daughters Adrienne and Switlana for their support.<a id="page_1"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226112251_06_ack.vue?5ec0f8d8